import { useQuery, UseQueryResult } from "react-query";

import { ApiRoutes } from "../../constants/ApiRoutes";
import { httpClient } from "../../api-legacy/BaseApi";

interface EventDetailParams {
  id: number;
  companyId: number;
}

export function useEventDetailQuery(
  params: EventDetailParams,
): UseQueryResult<any, Error> {
  return useQuery(
    ["app", "events", "detail", params.id, params.companyId],
    () =>
      httpClient
        .get(ApiRoutes.EventDetail, { params })
        .then(({ data }) => data),
    { enabled: !!params.id && !!params.companyId },
  );
}